var _path, _path2, _polyline, _polyline2, _line, _line2, _line3, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.703,12.241v2.004c0,4.762,3.281,9.131,7.329,9.131s7.329-4.37,7.329-9.131v-2.004"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m5.33,38.664v-4.754c0-1.924,1.15-3.662,2.92-4.414l9.256-3.934,3.462,3.825,3.526-3.825,9.256,3.934c1.771.753,2.92,2.49,2.92,4.414v4.754"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "21.032 29.387 17.161 31.469 15.85 26.607"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "20.968 29.387 24.839 31.469 26.15 26.607"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 21.032,
    y1: 36.079,
    x2: 21.032,
    y2: 29.387
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 11.344,
    y1: 38.628,
    x2: 11.344,
    y2: 37.353
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 30.631,
    y1: 38.628,
    x2: 30.631,
    y2: 37.353
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m16.049,13.413l-.066-.026c-1.495-.58-2.71-1.482-3.481-2.583l-.027-.039h17.051,0c-.766,1.126-1.993,2.049-3.511,2.64h0c-3.113,1.214-6.849,1.217-9.965.007Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m28.894,10.167l1.262-2.508c.321-.637-.143-1.389-.856-1.389h-1.47c-1.485,0-2.928-.485-4.111-1.382l-1.537-1.165c-.68-.516-1.62-.516-2.3,0l-1.537,1.165c-1.183.897-2.627,1.382-4.111,1.382h-1.502c-.706,0-1.169.737-.864,1.373l1.212,2.524"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorSecurity);
export default __webpack_public_path__ + "static/media/indoor-security.408d50c6a90012b9e24337779b73d8d9.svg";
export { ForwardRef as ReactComponent };